<div class="header-content">
  <app-header-menu></app-header-menu>
  <app-cobrand-lockup></app-cobrand-lockup>

  <div class="login-register">
    <ng-container *ngIf="!IframeMode">
      <app-account-chip *ngIf="isAuthenticated$ | async; else loginLinks"></app-account-chip>
      <ng-template #loginLinks>
        <app-login-logout></app-login-logout>
      </ng-template>
    </ng-container>
  </div>
</div>
